import React, { useState } from 'react';
import {
    Grid, TableContainer, Typography, Box, TableHead, TableRow, TableCell, IconButton, TableBody
} from '@mui/material';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { useAppSelector } from '../../app/hooks'
import { OrganizationMemberModel } from '../../typings';
import { StyledDetailTable } from '@lp/lp-ui';
import { NewOrganizationMemberModel } from '../../functions';
import { useCurrentUser } from '../../app/useCurrentUser';
import OrganizationMemberDialog from './OrganizationMemberDialog';

export default function UserOrganizationsPanel() {
    const userState = useAppSelector(store => store.user);
    const currentUser = useAppSelector(store => store.currentUser);
    const [organizationMemberDialogOpen, setOrganizationMemberDialogOpen] = useState<boolean>(false);
    const [organizationMember, setOrganizationMember] = useState<OrganizationMemberModel>(NewOrganizationMemberModel());
    const [, isTenantAdmin,] = useCurrentUser();

    const handleOrganizationMemberDialogClose = () => {
        setOrganizationMemberDialogOpen(false);
    };

    return (
        <React.Fragment>
            <Grid container spacing={0} columnSpacing={6}>
                <Grid item xs={12}>
                    <Typography variant="h5" color="primary">
                        Organizations
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <TableContainer component={Box}>
                        <StyledDetailTable size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Organization</TableCell>
                                    <TableCell>Organization Roles</TableCell>
                                    <TableCell align="right">
                                        {(isTenantAdmin && (userState?.data?.enabled ?? false) &&
                                        (currentUser.data?.organizations ? currentUser.data.organizations.some(o => !userState.organizations.some(uo => uo.organizationId === o.id)) : false)) &&
                                            <IconButton size="large"
                                                onClick={() => {
                                                    setOrganizationMember(NewOrganizationMemberModel());
                                                    setOrganizationMemberDialogOpen(true);
                                                }}
                                            >
                                                <AddCircleOutlineIcon />
                                            </IconButton>
                                        }
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {userState.organizations.map((row, i) => (
                                    <TableRow key={i}>
                                        <TableCell>
                                            {row.organizationDisplayName}
                                        </TableCell>
                                        <TableCell>
                                            {row.roles.map(r => r.name).join(", ")}
                                        </TableCell>
                                        <TableCell align="right">
                                            {(isTenantAdmin && (userState?.data?.enabled ?? false)) &&
                                                <IconButton size="large"
                                                    onClick={() => {
                                                        setOrganizationMember(row);
                                                        setOrganizationMemberDialogOpen(true);
                                                    }}
                                                >
                                                    <NavigateNextIcon />
                                                </IconButton>
                                            }
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </StyledDetailTable>
                    </TableContainer>
                </Grid>
            </Grid>

            <OrganizationMemberDialog
                open={organizationMemberDialogOpen}
                data={organizationMember}
                handleClose={handleOrganizationMemberDialogClose}
            />
        </React.Fragment>
    );
}
